import { CircleHelp } from "lucide-react";

import { useHelp } from "@/components/help/HelpProvider";

import { Button } from "./Button";

/**
 * "Get help with this": opens the help panel on the article for `helpKey`. Renders nothing where
 * there is no help panel (outside a signed-in organization, so no articles can be asked for).
 */
export function HelpLink({ helpKey }: { helpKey: string }) {
  const help = useHelp();
  if (!help) return null;
  return (
    <Button
      variant="ghost"
      aria-haspopup="dialog"
      icon={<CircleHelp className="size-4" aria-hidden />}
      onClick={() => help.open({ key: helpKey })}
    >
      Get help with this
    </Button>
  );
}
